// extracted by mini-css-extract-plugin
export default {"cls1":"FilterForm-Title_cls1__9nIXU","cls2":"FilterForm-Title_cls2__UmhG5 FilterForm-Title_cls1__9nIXU"};